<template>
  <div class="top-container">
    <el-carousel indicator-position="outside" height="400px" arrow="always">
      <el-carousel-item
        v-for="item in carouselItems"
        :key="item.id"
        class="carousel-item-container"
        :style="{ backgroundImage: `url(${item.img})` }"
      >
        <div class="carousel-caption">
          <h2>{{ item.title }}</h2>
          <p>{{ item.description }}</p>
        </div>
      </el-carousel-item>
    </el-carousel>

    <h2 class="news-text">ニュース</h2>
    <div class="news-container">
      <template v-for="item in newsItems">
        <div class="news-content">
          <p class="is-bold">{{ item.title }}</p>
          <span>{{ item.content }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      carouselItems: [
        {
          id: 1,
          title: "縁創株式会社",
          description: "クラウドサービスから企業データ分析までお任せください。",
          img: require("../assets/carousel/1.jpg"),
        },
        {
          id: 2,
          title: "DX化を推進",
          description: "企業のDX化の推進に貢献致します。",
          img: require("../assets/carousel/2.jpg"),
        },
      ],
      newsItems: [
        {
          id: 1,
          title: "2025年7月研修コース",
          content: "AWS、Azure、GCPの構築一回目社員研修完了。",
        },
        {
          id: 2,
          title: "2025年9月研修コース",
          content: "第二回社員向けAWS研修完了。",
        },
      ],
    };
  },
};
</script>

<style scoped>
* {
  color: #2c3e50;
}
.is-bold {
  font-weight: bolder;
  font-size: large;
}
.top-container {
  overflow-y: hidden;
}
.carousel-item-container {
  overflow-y: hidden;
  background-color: #f5f7fa;
  background-size: cover;
  border-radius: 8px;
}

.carousel-caption {
  position: absolute;
  z-index: 2;
  box-sizing: border-box;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  max-width: 900px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 20px;
  border-radius: 8px;
  text-align: left;
}

.carousel-caption h2 {
  margin-top: 0;
  font-size: 24px;
  color: white;
}

.carousel-caption p {
  font-size: 16px;
  margin-bottom: 0;
  color: white;
}
.news-text {
  text-align: center;
}
.news-container {
  align-items: center;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.news-container div {
  width: 50%;
}
.news-content {
  background-color: #409eff;
  color: white;
  padding: 1.25rem;
  margin-bottom: 0.5rem;
  border-radius: 8px;
}
.news-content p {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
}
.news-content span {
  font-size: 1rem;
  font-weight: 400;
}
</style>
